import React, { useEffect, useState } from 'react';
import { useFetch } from '../../hooks/useFetch';
import { LandingHeader } from './LandingHeader';
import { SimpleFooter } from '../footer/Footer';
import { Link } from 'react-router-dom';
import { apiConfig } from '../../api/apiConfig';
import WebChatZoomCrm from '../../assets/zoom-messenger-react/lib/addBubble';
const landingImages = require.context('../../assets/images', true);
const courseActionButtonPrefix = 'ab_course_';

export const LandingPage = () => {
  const [courses, setCourses] = useState([]);
  const [, handleFetch] = useFetch();
  const viewCourses = () => {
    const response = handleFetch({
      url: `catalog/b2bcatalog?company=${apiConfig.company}&$limit=5`, //price[$eq]=0
      method: 'GET',
    });
    response.then(
      (r) => {
        setCourses(r.data);
      },
      (error) => {
        console.log(error.errors);
      }
    );
  };
  const getPrice = (price) => {
    let formattedPrice;
    const CURRENCY = 'COP';
    const CURRENCY_SYMBOL = '$';
    const fn = Intl.NumberFormat('es-CO', {
      maximumFractionDigits: 0,
    });
    formattedPrice = CURRENCY + ' ' + CURRENCY_SYMBOL + fn.format(price);
    return formattedPrice;
  };
  // Función para mostrar tarjeta con información de cursos
  const CourseCardContainer = ({
    id,
    course,
    insideContent,
    onMouseEnter,
    onMouseLeave,
    className,
  }) => {
    const [, setTimer] = useState(0);
    const onTouchStart = (e) => {
      if (onMouseEnter) {
        const _timer = setTimeout(() => onMouseEnter(e), 200);
        setTimer(_timer);
      }
    };
    return (
      <div
        className={className}
        id={id}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onTouchStart={onTouchStart}
      >
        <div className="row justify-content-center justify-content-sm-start m-0">
          <div className="col-12 p-0">
            <div className="row mx-sm-2 mt-2 position-relative">
              <div className="col-12 p-0">
                {course['course.imageUrl'] ? (
                  <img
                    alt={'Course thumbnail ' + course['course.name']}
                    src={course['course.imageUrl']}
                    className="CourseCard__image"
                  />
                ) : (
                  <img
                    alt={'Course thumbnail ' + course['course.name']}
                    src="http://eanx-api.eastus2.cloudapp.azure.com/dev/catalog/images/curso22.jpeg"
                    className="CourseCard__image"
                  />
                )}
                <div className="row CourseCard__price justify-content-center">
                  {getPrice(course['price'])}
                </div>
              </div>
            </div>
            {insideContent}
          </div>
        </div>
      </div>
    );
  };
  // Función para mostrar información básica de cursos
  const CourseBasicData = ({ course }) => {
    return (
      <>
        <div className="col-12 ">
          <div className="row">
            <div className="col-12">
              <p className="CourseCard__text mb-0 mt-1">{course['course.name']}</p>
            </div>
          </div>
        </div>
        <div className="justify-content-center text-center">
          <Link className="text-center" to={`/curso/${course['course.courseId']}`}>
            <div
              className="BestCourses__button-primary mb-3"
              id={`${courseActionButtonPrefix}${course['id']}`}
            >
              Ver curso
            </div>
          </Link>
        </div>
      </>
    );
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    viewCourses();
  }, []);

  return (
    <>
      <LandingHeader />
      <div id="contWebChatZoomCrm">
        <WebChatZoomCrm
          elementId="contWebChatZoomCrm"
          backgroundColor="#3BAC53"
          color="#FFFFFF"
          socialGatewayUrl="https://socialgateway.verzia.io/modules/zoomWebChat/zoomMessengerLog.php?params=N3hMWEdVWndFVytYQnE4cU4xSm1pMlhRaHVvSXVPRmVuNjQrdGFvS0o4cTZaOSt2eFEyNmhoM1Y3TDk1MWNXZFhUbld3YXlEOUdEUlliTUVvYkFkVGEvMHJlNS9pQVFyTXc1MTVOZGNPRW9LN0VsZFNwdFllRFBCVzhrYm1HZ1YyeXFDVE9TUlZYdTBuUE9TbnVaTHM2RkNJVGErSGNDTTFvek5EeXNuc3dhOTJ6RG1TcXdGSmV2eFMwbEJZSmtuUzA0M2cxQ2c5cEpwV1Y2Z1pGZ3lmZ3JHeVp0cFdxTk5UaWZVSStQMmZYR2gxWXVwV2tUWithQzFxTnIwSzFTZmdtenNva0U5NHlaM3pxY3RJVkFQUnl6d1N4MHJONFplem1EN3o5dGc3VUkrR0U3Z05BekE0V2NKNW9NRjl3dldVMUYyUnRYV05yeFk0Q2dDR1VtTDdRd1FtL1BkVUp5U01obktRN2lSeThuWWJaZmtMTkUrcjgyVFFJMFFCM1NKM1p4ckNOUW5sTy9LYWFWbWhqYTJYQWtXTEVjbXoyNDRFd2s1OXNsTlI2R0VuNmVNdHhEbE1hQVdRTER0Wk5rcnVkU0g3Wk9TNmc3QkJRUlRkTnJDbHA2ZXpvVW5SbkFjMlFFK2xLUmhVUHRPQU83S0xmOWd6elkvZ01XeTdqM1BoaDIwQzFEMk12N2pUZitJNFMwYkdFcWUweHJyeFlNSUwxWkhMUXFxMlpCRUpUZFY3dGpsazdBcEtoRS9OdjlrdnphUDcrTnNWQ0xXQWJRWjBMTXlBQmJuekxleFZDbzBWcDkyUzU2dks5b0NxT3l0Vk4xRk5Majlldytqcy9hbk1nSndTVVBRRXlZQlVuMitsYkNpVGtTaVhRdElaa0VyVDMvc3pNSjRvUUdnUlpOdVV5NWpsOUJJSjhnY0hQbC80Z2s5YjE3akZraHVwZ0EzZitFdFIzSEloTERJM0ozSUlua3RZMTNQdm02ZERVM0ZUdjBsaUVLTjk0SGxEN2Y2KzRjWDNXS2tqakVlWGhlRmdxY1Z0WnNWSVhJVjdTclljV09QaUFQbWxsSE1xWldoUzdlN3BGSWtqb0dJV0l5cmFnNnFqNEtWc3VuRnhmNmhsY1FTa1NINGZNYlJBYkdSU2pZZlpKM3d4S1R3MUZrQkpRbVJyVG00SWFYS1RvVzNmOWNTbHF4WWNXWGRZVmV0QXZ5M3V6d1B5TkdpbXhORXJjTUdoWDRQWmo1Z1RxcWxGTzFNNWt4RWZQakh3QzNNcm9GU0hXcGNldDkwR01CbGhmMHlXQ09pck1oT3o4S1NrVkw1U1dNQUY0aURuampZMHBrdldBN0xHUlNmeSt1M0hNbm1iNXV4REh4bWJ3R1VSWFZFaXhnR0ZwQVV5MWhadFZTV1htelFZYjdzR3Y4VE5OY2svQjNMZjdHY0h0MGFCR2lSdEF1TkhmQ2lSZFBDV2VMczQ3ZXU1N1FzZzA5RmxDd21JV3R1WkE1WWJIclFCamJNKytuNVhNeE1TempUTXEzY1lYY0QxSzBmQ01GZnp5bHhna0lrYVB3Y1BVTW11TU45TUxRLzczYz0="
        />
      </div>
      <div style={{ marginTop: '100px' }}></div>
      <div className="landing__container-background">
        <div className="container my-2 my-xl-5">
          <div className="row justify-content-lg-center align-items-center mt-2">
            <div
              className="col-12 d-block d-lg-none"
              style={{ overflow: 'hidden', textAlign: 'center', margin: '0 auto' }}
            >
              <img
                alt="Woman posing"
                src={landingImages('./woman-posing.png')}
                className="img-fluid"
                width="300"
                height="200"
              />
            </div>
            <div className="col-xl-7 col-lg-7 col-md-12 col-12 mt-4">
              <div className="row">
                <div className="col-12 landing__text-comunidad-monet">
                  <span className="landing__text-color-green">¡Impulsa tu futuro</span>
                  <br />
                  <span className="text-white">con EANX y MONET!</span>
                </div>
              </div>
              <div className="row my-4">
                <div className="col-12 landing__paragraph-text">
                  <p className="text-white">
                    Aprende de finanzas, marketing y emprendimiento <br />
                    <span className="fw-bold text-white">
                      a un precio exclusivo de $10.000 COP por curso.
                    </span>
                  </p>

                  <p className="landing__text-color-green fw-bold">
                    Por ser usuario Monet te regalamos los 2 primeros módulos.
                  </p>
                </div>
              </div>
              <div className="row text-center  justify-content-center justify-content-md-start">
                <Link
                  to="/planes/monet-plan-gratuito"
                  className="col-11 col-md-4 col-lg-5 landing__button-primary"
                >
                  ¡Inscríbete gratis! <i className="fa-solid fa-arrow-right mx-2"></i>
                </Link>
              </div>
            </div>
            <div className="col-lg-5 col-xl-5 d-flex justify-content-end pe-0 d-none d-lg-grid">
              <img
                alt="Woman posing"
                src={landingImages('./woman-posing.png')}
                className="img-fluid"
                width="300"
                height="478"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="landing__container-courses">
        <div className="container my-2 my-xl-5">
          <div className="row justify-content-lg-center align-items-center mt-2">
            <div className="col-12 landing__text-comunidad-monet text-center">
              <span className="landing__text-color-green">
                Lleva tu negocio y tu vida financiera
              </span>
              <br />
              <span className="text-white"> a otro nivel con estos cursos</span>
            </div>
            <div className="col-12 landing__paragraph-text mt-3 text-center">
              <p className="text-white">
                Por ser usuario Monet, recibe 2 módulos gratuitos en cualquier curso que elijas,
                <br /> completa el resto de los módulos por solo $10.000 y certifícate ¡Ahora!
              </p>
            </div>
            <div className="justify-content-center mt-4">
              {courses && (
                <>
                  <div className="row">
                    {courses.slice(0, 3).map((item, index) => (
                      <div key={index} className="col-md-4 mb-3">
                        <div className="text-white">
                          <CourseCardContainer course={item} />
                          <div className="row justify-content-start align-items-center text-start mx-sm-2 mb-2 CourseCard__container-text">
                            <CourseBasicData course={item} />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="row justify-content-center">
                    {courses.slice(3, 5).map((item, index) => (
                      <div key={index} className="col-md-4 mb-3">
                        <div className="text-white">
                          <CourseCardContainer course={item} />
                          <div className="row justify-content-start align-items-center text-start mx-sm-2 mb-2 CourseCard__container-text">
                            <CourseBasicData course={item} />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="message__bottom">
          <div className="content">
            <div className="row">
              <div className="col-12 landing__text-comunidad-monet text-white text-center">
                ¡Comienza a impulsar tu futuro
                <br /> ahora con MONET y EANX!
              </div>
              <div className="col-12">
                <div className="row text-center justify-content-center">
                  <Link
                    to="/planes/monet-plan-gratuito"
                    className="col-11 col-md-4 col-lg-5 landing__button-bottom"
                  >
                    ¡Inscríbete gratis! <i className="fa-solid fa-arrow-right mx-2"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SimpleFooter />
    </>
  );
};
